const API_URL = "https://minegestdepenses.pro-aquacademy.com";
export default API_URL;
